// Pure helpers backing AdvancedSearchBar. Kept out of the component so the .tsx
// holds only rendering and state.

import { ClauseToken, SearchToken } from 'helpers/searchGrammar';
import { FieldDescriptor } from 'types/advancedSearch';

/** Typing narrower for the clause arm of a token union. */
export const isClause = (token: SearchToken): token is ClauseToken => token.type === 'clause';

/** Human-readable value for a committed clause chip (maps enum values → labels). */
export function displayValues(clause: ClauseToken, descriptor?: FieldDescriptor): string {
  const options = [...(descriptor?.emptyOption ? [descriptor.emptyOption] : []), ...(descriptor?.options ?? [])];
  if (!options.length) return clause.values.join(', ');
  return clause.values
    .map(value => {
      const option = options.find(o => o.value === value);
      return option?.searchText ?? (typeof option?.label === 'string' ? option.label : value);
    })
    .join(', ');
}

/**
 * Descriptor to edit a committed clause with. Falls back to a plain text field so
 * clauses whose key is not in the schema (legacy `q` values, pro columns) stay
 * editable rather than becoming read-only chips.
 */
export function descriptorFor(
  clause: ClauseToken,
  byWireKey: Map<string, FieldDescriptor>,
): FieldDescriptor {
  return byWireKey.get(clause.field ?? '') ?? { label: clause.field ?? '', kind: 'text' };
}
